const routes = {
  root: '/status',
}

export default routes
